// 報告書の明細は「1測定場所あたり3行」を前提にレイアウトされている
// （報告書詳細・帳票・作成／編集／複製画面がいずれも rowspan="3" 固定）。
// 測定回数が3回未満のデータ（IES4取込など）でも列がずれないよう、行数を揃える。
export const REPORT_CONTENT_ROWS = 3;

// 空行の初期値。平均値計算は null / '' を除外するため、集計値には影響しない。
export const buildEmptyMeasurementContent = (measurementCount) => ({
  measure_time: null,
  measurement_count: measurementCount,
  room_people_num: null,
  smoker_no: null,
  dry_bulb: '',
  wet_bulb: '',
  relative_humidity: '',
  air_current: '',
  co2_itt: '',
  co_itt: '',
  float_powder_dust_itt: '',
  illuminance: '',
  noise: '',
  formaldehyde: '',
  remarks: ''
});

// 入力フォーム用: 読み込んだ測定場所の明細を3行に揃える（不足分は空行を追加）
export const normalizeWorkPlaceContents = (workPlaces) => {
  (workPlaces || []).forEach((workPlace) => {
    if (!workPlace) return;
    if (!Array.isArray(workPlace.t_measurement_work_place_contents)) {
      workPlace.t_measurement_work_place_contents = [];
    }

    const contents = workPlace.t_measurement_work_place_contents;
    while (contents.length < REPORT_CONTENT_ROWS) {
      contents.push(buildEmptyMeasurementContent(contents.length + 1));
    }
  });

  return workPlaces;
};
